<script setup lang="ts">
import type { BadgeProps } from '.';

import { cn } from '@/utils';

import { badgeVariants } from '.';

const props = defineProps<BadgeProps>();
</script>

<template>
	<div :class="cn(badgeVariants({ variant }), props.class)">
		<slot></slot>
	</div>
</template>
